import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { isValidEnumValue, MuiColor } from '../utility';


let nextId = 0;

@Component({
  selector: 'mui-banner',
  templateUrl: './mui-banner.component.html',
  styles: [':host { display: block; }']
})
export class MuiBanner {

  @Input()
  @HostBinding('attr.id')
  id = `mui-banner-${nextId++}`;

  @Input() message?: string;
  @Input() color?: MuiColor | string;
  @Input() icon = 'check';
  @Input() class = '';

  @HostBinding('attr.role')
  readonly role = 'region'; // 'banner' should only be used for the page header

  @HostBinding('attr.aria-describedby')
  get ariaDescribedBy(): string {
    return this.id + '-content';
  }

  get showDismiss(): boolean {
    return this.dismiss.observed;
  }

  @Input()
  dismissButtonLabel = 'Close';

  @Output()
  dismiss = new EventEmitter<void>();

  @HostBinding('class')
  get buttonConfigClass(): string {
    const classes = [
      this.class, // include original classes from the DOM element
      'mui-banner',
      `mui-banner--${isValidEnumValue(MuiColor, this.color) ? this.color : MuiColor.DEFAULT}`
    ];

    return classes.join(' ');
  }
}
